// test325
(325 && 0);
